const CUSTOMER_LOGO_BASE = 'https://cloudinary-res.cloudinary.com/image/upload/d_console:cld_default_cloud_logo.svg/w_32,h_32,c_fill,dpr_2.0';
const CUSTOMER_LOGOS_DIR = 'console/customer-logos';

export const fromAccountId = (accountId) => (accountId ? `${CUSTOMER_LOGO_BASE}/${CUSTOMER_LOGOS_DIR}/${accountId}` : CUSTOMER_LOGO_BASE);
export const fromPath = (logoPath) => (logoPath ? `${CUSTOMER_LOGO_BASE}/${logoPath}` : CUSTOMER_LOGO_BASE);
